import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/StationSpeakers/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/StationSpeakers/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/StationSpeakers/GetById`, payload),
    Add: (payload) => Repository.post(`/api/StationSpeakers/Add`, payload),
    Edit: (payload) => Repository.post(`/api/StationSpeakers/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/StationSpeakers/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/StationSpeakers/ChangeStatus`, payload),
}
